import { maxLength } from '@carboledger/ui';
import { emailRule, referenceIdNumberRule, positiveNumberRule } from '@/lib/validation';
import { getTranslation } from '@/lib/utils/i18n';
import { ORGANIZATION_NAME_MAX_LENGTH } from './constants/customers.constants';

// Format rules for the customer, site and transportation forms; `required` lives on each <Field>.

export const customerValidation = {
  organizationName: [
    maxLength(
      ORGANIZATION_NAME_MAX_LENGTH,
      getTranslation('VALIDATION_MAX_LENGTH', { max: ORGANIZATION_NAME_MAX_LENGTH }),
    ),
  ],
  idNumber: referenceIdNumberRule,
  email: emailRule,
};

export const customerSiteValidation = {
  idNumber: referenceIdNumberRule,
  email: emailRule,
};

export const transportationValidation = {
  distance: positiveNumberRule,
  emissionFactor: positiveNumberRule,
};
